import React from 'react';
import { useAddToCart, useCart } from '@src/hooks/cart';

import { navigate } from '@reach/router';
import { Link } from 'gatsby';
import posthog from 'posthog-js';

export const buttonStyles = {
  margin: 0,
  padding: '0 5px',
  textDecoration: 'none',
  color: 'white',
};

const CartButton = ({ id }: { id: string }) => {
  const { addToCart } = useAddToCart();
  const { ownedProducts, miniCart } = useCart();

  const isOwned = ownedProducts.has(id);
  const isInMiniCart = miniCart.has(id);

  const handleAddToCart = (id: string, isInMiniCart: boolean) => {
    if (isInMiniCart) {
      navigate('/cart');
    } else {
      addToCart(id);
      posthog.capture('cart_item_added', { document_id: id });
    }
  };

  if (isOwned) {
    return (
      <div className="category-option-info">
        <button
          onClick={() => navigate('/profile')}
          className="button-b badge free-sample"
          style={buttonStyles}
        >
          Purchased
        </button>
      </div>
    );
  }

  if (isInMiniCart) {
    return (
      <div className="category-option-info">
        <Link to="/cart" className="button-b badge free-sample" style={buttonStyles}>
          In Cart
        </Link>
      </div>
    );
  }

  return (
    <div className="category-option-info">
      <button
        style={buttonStyles}
        className="button-b badge free-sample"
        onClick={() => handleAddToCart(id, isInMiniCart)}
      >
        Buy
      </button>
    </div>
  );
};

export default CartButton;
